import React, { useState } from 'react';
import './CoachingReviewed.css';
import CoachingMessage from './CoachingMessage';

const CoachingReviewed = ({ suggestions }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="coaching-reviewed-container">
      <div 
        className="reviewed-header"
        onClick={toggleExpanded}
      >
        <div className="reviewed-title">
          <i className="ti ti-check"></i>
          <span>Previous Coaching Points</span>
        </div>
        <div className="reviewed-count">
          {suggestions.length}
        </div>
        <div className="reviewed-toggle">
          <i className={`ti ${isExpanded ? 'ti-chevron-down' : 'ti-chevron-right'}`}></i>
        </div>
      </div>
      
      {isExpanded && (
        <div className="reviewed-content">
          {suggestions.map((suggestion, index) => (
            <CoachingMessage 
              key={`reviewed-${suggestion.increment}-${index}`}
              suggestion={suggestion}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CoachingReviewed;
